import { AppLogoBase } from 'features/app-logo/components';
import { Badge } from 'features/ui/elements';

export const AppLogoEmergency = () => {
  return (
    <AppLogoBase>
      <Badge severity='darkError'>VRS</Badge>
    </AppLogoBase>
  );
};
